/**
 * The workspace tab set is stored per site and per document corpus, and that
 * is the whole grammar: `<siteId>:<active|preview>`. Scopes carrying anything
 * else (an embedded viewer's own bucket, another site) belong to a different
 * tab state and must never re-scope the workspace — adopting one parks the
 * user's open tabs in the old bucket and swaps in an unrelated set.
 */
export type WorkspaceScopeMode = 'active' | 'preview'

export const workspaceScope = (
  siteId: string,
  mode: WorkspaceScopeMode
): string => `${siteId}:${mode}`

export const workspaceScopeMode = (scope: string): WorkspaceScopeMode =>
  scope.endsWith(':preview') ? 'preview' : 'active'

export const isWorkspaceScopeForSite = (
  scope: string,
  siteId: string
): boolean =>
  scope === workspaceScope(siteId, 'active') ||
  scope === workspaceScope(siteId, 'preview')
